import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Question } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';

@Component({
  selector: 'lib-caption-offcanvas',
  templateUrl: './caption-offcanvas.component.html',
  styleUrls: ['./caption-offcanvas.component.scss']
})
export class CaptionOffcanvasComponent implements OnChanges {
  @Input() isCollapsed = true;
  @Input() caption!: Question;
  @Output() childData = new EventEmitter();
  @ViewChild('inputCaption') inputCaption!: ElementRef;

  public config = {
    toolbar: [],
    disableResizeEditor: true,
  };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caption'] && changes['caption'].currentValue) {
      this.caption = changes['caption'].currentValue;
    }

    if(changes['isCollapsed'] && changes['isCollapsed'].currentValue == false && this.inputCaption) {
      setTimeout(() => {
        this.inputCaption.nativeElement.focus();
      }, 0);
    }
  }

  cancelCaption() {
    this.childData.emit({ key: 'close' });
  }

  saveCaption() {
    this.childData.emit({ key: 'save', data: this.caption });
  }

  isDisabled() {
    return this.caption.statement === '' ? 'disabled' : '';
  }
}
